import { defineStore } from 'pinia';
import { ref } from 'vue';
import axios from 'axios';
import type { Styles } from '@/types';
import { mainDomain, storageDomain } from '@/utils/variables';
import { useDocumentTitle } from '@/composables/useDocumentTitle';

export const useStylesStore = defineStore('styles', () => {
    // Ref with defined `Styles` interface
    const { setTitle } = useDocumentTitle();
    const logo = ref<string>('');
    const titlePage = ref<string>('');
    // Function to set the favicon
    function toSetFavicon(url: string): void {
        const faviconUrl = `https://${storageDomain}/ui-style/${url}`;
        let favicon = document.getElementById('favicon') as HTMLLinkElement;

        // If the favicon link element doesn't exist, create it
        if (!favicon) {
            favicon = document.createElement('link');
            favicon.id = 'favicon';
            favicon.rel = 'icon';
            document.head.appendChild(favicon);
        }

        // Set the href to the new URL
        favicon.href = faviconUrl;
    }

    // Function to set colors in the document
    function toSetColors(colors: { [key: string]: string }): void {
        Object.entries(colors).forEach(([key, value]) => {
            document.documentElement.style.setProperty(key, value);
        });
    }

    // Async function to fetch and set styles
    const awaitGetStyles = async () => {
        try {
            const response = await axios.get<Styles>(`/main-api/ui_style/active?domain=${mainDomain}`);
            if (response.status === 200) {
                const rd = response.data;
                toSetColors(rd.css_json);
                toSetFavicon(rd.favicon_img);
                // document.title = rd.title || mainDomain;
                titlePage.value = rd.title || mainDomain;
                setTitle(titlePage.value);
                logo.value = `https://${storageDomain}/ui-style/${rd.logo_img}`;
            }
        } catch (error) {
            console.error(error);
        }
    };
    return { awaitGetStyles, logo, titlePage };
});
